import React from 'react';
import s from '../solution-rate-reviews.scss';

import { Text, Box, TextButton } from '@wix/design-system';
import { composer } from '../../../../../component-decorators/composer';
import type { TFunction } from 'i18next';

interface IReviewBodyProps {
  title?: string;
  body?: string;
  id?: string;
  isMobile: boolean;
}

export class ReviewBody extends React.Component<IReviewBodyProps, any> {
  constructor(props) {
    super(props);
    this.state = {
      isLongReview: this.isBodyTooLong(props.body),
      expandedBody: false,
    };
    this.getReviewBodyText = this.getReviewBodyText.bind(this);
    this.expandToggle = this.expandToggle.bind(this);
  }

  isBodyTooLong(body: string) {
    return body && body.split(' ').length > 34;
  }

  getReviewBodyText() {
    return this.state.isLongReview && !this.state.expandedBody
      ? reviewBodySlicer(this.props.body)
      : this.props.body;
  }

  expandToggle() {
    this.setState((prevState) => {
      return {
        expandedBody: !prevState.expandedBody,
      };
    });
  }

  render() {
    return (
      <Box marginBottom={this.props.isMobile ? '0px' : '5'}>
        {!this.props.isMobile && <Box width="55px" />}
        <Box direction="vertical" marginLeft="2">
          {this.props.title ? (
            <Text size="medium" weight="bold">
              {this.props.title}
            </Text>
          ) : null}
          <Text
            property="reviewBody"
            dataHook={`review-${this.props.id && this.props.id}`}
            className={s.reviewBody}
            size="medium"
          >
            {this.getReviewBodyText()}
          </Text>
          {this.state.isLongReview && (
            <TextButton
              dataHook={`review-body-expander-${this.props.id}`}
              onClick={this.expandToggle}
            >
              {this.state.expandedBody ? (
                <TranslatedKey tkey="solution.page.review.readLess" />
              ) : (
                <TranslatedKey tkey="solution.page.review.readMore" />
              )}
            </TextButton>
          )}
        </Box>
      </Box>
    );
  }
}

export const reviewBodySlicer = (body: string): string => {
  return (
    body
      .split(' ')
      .slice(0, 33)
      .map((word) => word + ' ')
      .reduce((a, b) => a + b, '')
      .replace(/\s*$/, '') + '...'
  );
};

const TranslatedKey = composer()
  .withTranslation()
  .compose(({ t, tkey }: { t?: TFunction; tkey: string }) => t(tkey));
